import React, { Component } from "react";

import styles from "./styles.css";

export class AccordionDetails extends Component {
  render() {
    const { image, title, description, benefits} = this.props;

    return (
      <div className={styles.container}>
        <img src={image} alt={title} />

        <div className={styles.container__column}>
          <h3>{title}</h3>
          <p>
            {description}<br />
            <div dangerouslySetInnerHTML={{__html: benefits}} />
            
          </p>
          
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/event/PrizeAccordion/AccordionDetails/index.jsx